/**
 * De tekst van een melding op de bel, in de taal van de lezer. Puur, zodat hij zonder DOM te
 * toetsen is.
 *
 * Een soort kan per documentsoort een eigen tekst hebben: `notifications.kind.<soort>_<documentType>`
 * (bv. bij een goedgekeurde inkooporder de hint dat je hem nu kunt versturen). Zonder die variant
 * de gewone tekst van de soort. Dezelfde regel als de mail (`apps/backend/src/lib/approval/notify.ts`).
 */
type T = (key: string, vars?: Record<string, string>) => string

export function notificationText(
  row: { kind: string; params: Record<string, unknown> },
  vars: Record<string, string>,
  t: T,
): string {
  const base = `notifications.kind.${row.kind}`
  const documentType = row.params.documentType
  if (typeof documentType === 'string' && documentType) {
    const key = `${base}_${documentType}`
    // gt-react geeft voor een ontbrekende sleutel `''`; een eigen vertaler soms de sleutel zelf.
    const s = t(key, vars)
    if (s && s !== key) return s
  }
  return t(base, vars)
}
